export const RESUME_SEEK_RETRY_DELAY_MS = 250;
export const RESUME_SEEK_MAX_RETRIES = 12;
